import React, { useState } from "react"

const Img = ({ fallback, src, srcSet, aspectRatio, className, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const _aspectRatio = aspectRatio ? aspectRatio : "16/9"
  return (
    <div className={`w-full aspect-w-16 aspect-h-9 ${className}`} {...props}>
      <div className=" w-full h-full">
        <img
          className="image-full absolute top-0 left-0"
          src={fallback}
          alt=""
        />

        {!isLoaded && (
          <div className="absolute inset-0 w-full h-full flex justify-center items-center bg-gray-50">
            <div class="load-wraper">
              <div class="activity"></div>
            </div>
          </div>
        )}

        {Array.isArray(src) ? (
          src.map((href, index) => (
            <img
              key={index}
              className="image-full absolute top-0 left-0"
              src={href}
              srcSet={srcSet}
              alt=""
            />
          ))
        ) : (
          <img
            className="image-full absolute top-0 left-0"
            srcSet={srcSet}
            src={src}
            onLoad={() => setIsLoaded(true)}
            alt=""
          />
        )}
      </div>
    </div>
  )
}

export default Img
